type Props = {};

function LogoV2Sub({}: Props) {
  return (
    <img
      src="https://firebasestorage.googleapis.com/v0/b/vealth1st-bd956.appspot.com/o/Object.png?alt=media&token=8db5b5af-86d0-4070-a90f-dc05b8298b7f"
      alt="logo"
      height="40px"
      width="110px"
    />
  );
}

export default LogoV2Sub;

